import * as Y from "yjs";
import { WebsocketProvider } from "y-websocket";
import React, { useState,useEffect, useMemo } from "react";
import { useSetYData } from "../uiEventHandler";
import '../style.css';
import {  handleButtonClick, handleCloseClick, handleMemoClick, handleDicisionClick, submitForm ,openTask,historyDisplay,openNameDicision} from '../uiEventHandler';
//import initializePackery from '../dragdrop';
//import yLevelDB from 'y-leveldb';
import { LeveldbPersistence } from 'y-leveldb';


//import taskDropTest, { taskReSize } from "../moveTask";
import {dragMoveStart,dragMoveEnd,taskReSize,resizeObserver,handleItemClick} from "../moveTask";
import { useLocation } from "react-router-dom";
import { wait } from "@testing-library/user-event/dist/utils";

const persistence = new LeveldbPersistence('./storage-location');

const yDoc = new Y.Doc();

let wsProvider;
/*
wsProvider = new WebsocketProvider(
  "ws://localhost:3002",
  `sprintboard`,
  yDoc
);
*/

let userId ;

//stateMemo
//resize,restore,delete,edit,move,make,SprintTotal,ChangeCurrentSprint,playerLogin

function setWebsocketProvider(){

  const location = useLocation();
  const teamNumberNum = location.state ? location.state.teamNumber : null;
  
  if(wsProvider == null){
    wsProvider = new WebsocketProvider(
      "wss://night.eng.tamagawa.ac.jp/ws",
      `sprintboard-${teamNumberNum}`,
      yDoc
    );
  }
  yDoc.on("sync" ,() => {
    console.log("kanryou");
  })

  wsProvider.once("sync",(isSynced) => {
    console.log("web socket Synce");
  })
}




//export const yData = yDoc.getMap("sprintboard:data");
export let yData;


const maps = [
  "ProductBacklog",
  "SprintBacklog",
  "investigation0","investigation1","investigation2","investigation3","investigation4",
  "doing0","doing1","doing2","doing3","doing4",
  "done0","done1","done2","done3","done4",
];
function changeWH(classId,elementId,width,height){
  const elemData = yData.get(classId).get(elementId);

  const time = getCurrentDate();
  const currentZIndex = elemData.zIndex ?? 1;
  const newZIndex = bringToFromt(yData.get(classId),currentZIndex);
  const updatedTask = {...elemData,width,height,time,zIndex:newZIndex};
  if(Math.abs((elemData.width || 0) - width) > 0.1 || Math.abs((elemData.height || 0) - height) > 0.1){

    applyYjsUpdate({
      actionType: "resize",
      actionGrid: classId,
      actionTaskKey: elementId,
      actionTaskTitle: yData.get(classId).get(elementId).taskTitle,
      yjsUpdate: () => {
        yData.get(classId).set(elementId,updatedTask);
      }
    })
  }

  
  
}

function restoreSprint(selectYData,tempTeamNum){
  const time = getCurrentDate();
  const teamNumber = location.state ? location.state.teamNumber : null;
  const protectedKeys = ["SprintInfo","taskCount"]

  applyYjsUpdate({
    actionType: "restore",
    actionGrid: null,
    actionTaskKey: null,
    actionTaskTitle: null,
    yjsUpdate: () => {
      
      yData.forEach((currentValue,key) => {
        //スプリントの総数や現在のスプリント、今までのタスクの総数は変わらず保持
        if(protectedKeys.includes(key))return;

        //既存のデータを削除
        if(currentValue instanceof Y.Map){
          currentValue.clear();
        }
        else{
          yData.delete(key);
        }

      });

      //中身復元
      selectYData.forEach((value,key) => {
        if(protectedKeys.includes(key))return;

        if(value instanceof Y.Map){
          if(!(yData.get(key) instanceof Y.Map)){
            yData.set(key,new Y.Map());
          }

          const targetMap = yData.get(key);

          value.forEach((taskValue,taskKey) => {
            targetMap.set(taskKey,JSON.parse(JSON.stringify(taskValue)));
          })
        }
        else{
          yData.set(key,value);
        }
      })
    }
  });
}


function deleteTask(gridName,key){

  applyYjsUpdate({
    actionType: "delete",
    actionGrid: gridName,
    actionTaskKey: key,
    actionTaskTitle: yData.get(gridName).get(key).taskTitle,
    yjsUpdate: () => {
      yData.get(gridName).delete(key);
    }
  })

}

function editTask(gridName,key,taskTitle,creatorName,difficulty,content,memo,taskColor){
  const task = yData.get(gridName).get(key);

  const time = getCurrentDate();
  const currentZIndex = task.zIndex ?? 1;
  const newZIndex = bringToFromt(yData.get(gridName),currentZIndex);

  const updatedTask = {
    ...task,
    taskTitle: taskTitle,
    creator: creatorName,
    time: time,
    difficulty: difficulty,
    content: content,
    memo,
    taskColor,
    zIndex:newZIndex
  }
  
  applyYjsUpdate({
    actionType: "edit",
    actionGrid: gridName,
    actionTaskKey: key,
    actionTaskTitle: taskTitle,
    yjsUpdate: () => {
      
      //yData.get(gridName).set(key,updateTaskData);
      yData.get(gridName).set(key,updatedTask);
    }
  })

}

//時間を取得してYYYY-MM-DD HH:mm:ss方式にしてreturnする
function getCurrentDate(){
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2,"0");
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

function updateMemberName(){
  const name0 = document.getElementById("name0").value;
  const name1 = document.getElementById("name1").value;
  const name2 = document.getElementById("name2").value;
  const name3 = document.getElementById("name3").value;
  const name4 = document.getElementById("name4").value;

  yDoc.transact(() => {
    yData.get("MemberName").set("0",name0);
    yData.get("MemberName").set("1",name1);
    yData.get("MemberName").set("2",name2);
    yData.get("MemberName").set("3",name3);
    yData.get("MemberName").set("4",name4);
  });
}



function applyYjsUpdate({actionType,actionGrid,actionTaskKey,actionTaskTitle,yjsUpdate}){
  const time = getCurrentDate();
  yDoc.transact(() => {
    yjsUpdate();
    

    yData.get("TaskAction").set("changeTime",time);
    yData.get("TaskAction").set("editedMember",userId);
    yData.get("TaskAction").set("sprintState",actionType);
    yData.get("TaskAction").set("actionGrid",actionGrid)
    yData.get("TaskAction").set("actionTaskKey",actionTaskKey);
    yData.get("TaskAction").set("actionTaskTitle",actionTaskTitle);
  })
}


const Sprintboard = () => {
  const [data,setData] = useState({});
  const [yDataState,setYDataState] = useState(null);
  let taskCount ;

  const location = useLocation();
  const teamNumber = location.state ? location.state.teamNumber : null;
  userId = location.state ? location.state.userID : null;

  if(yData == null){
    console.log("yData == null");
    //console.log("yData == null",yData.toJSON());
    //yData = yDoc.getMap(`sprintboard-${teamNumber}:${teamNumber}`);
    //yData = yDoc.getMap(`sprintboard:${teamNumber}`);
  }
  
  
  const updateDataOnTaskMove = (dragStartClassId,dragEndClassId,droppedElementId,elemLeft,elemTop) => {
    const time = getCurrentDate();
    const elementData = yData.get(dragStartClassId).get(droppedElementId);

    const currentZIndex = elementData.zIndex ?? 1;
    const newZIndex = bringToFromt(yData.get(dragEndClassId),currentZIndex);

    const updatedTask = {...elementData,time,elemLeft,elemTop,zIndex:newZIndex};
    const actionType = dragStartClassId === dragEndClassId ? "move" : "move-between";
    applyYjsUpdate({
      actionType: actionType,
      actionGrid: dragEndClassId,
      actionTaskKey: droppedElementId,
      //まだ移動処理前のためdragStartClassIdでタイトル取得
      actionTaskTitle: yData.get(dragStartClassId).get(droppedElementId).taskTitle,
      yjsUpdate: () => {
        if(dragStartClassId != dragEndClassId){
          yData.get(dragStartClassId).delete(droppedElementId);
        }
        yData.get(dragEndClassId).set(droppedElementId,updatedTask);
      }
    })
    
    
  }
  

  function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  //サーバに接続したタイミングで初期化してしまう問題発生(解決済み？)
  //syncでデータ同期舌タイミングを取得(localにデータが落ちてきているわけではない)
  //待ち時間を作らないとデータが反映されない場合が存在し、初期化してしまう
  //理想は、初期化はsyncのタイミング、yDataが存在する場合はsyncとupdateがどちらも起こった後
  //初回にデータの更新を行い，updateを監視するイベントを設定
  useEffect(() => {
    let isSynced = false;
    let isUpdate = false;

    
    function handleSync(isSynced){
      if(isSynced){
        const initilezation = async () => {
          await wait(500);
          yData = yDoc.getMap(`sprintboard-${teamNumber}:${teamNumber}`);

        yDoc.transact(() => {
          if (!yData.has("ProductBacklog")) {yData.set("ProductBacklog", new Y.Map());}
          if (!yData.has("SprintBacklog")) {yData.set("SprintBacklog", new Y.Map());}
          if (!yData.has("investigation0")) {yData.set("investigation0", new Y.Map());}
          if (!yData.has("investigation1")) {yData.set("investigation1", new Y.Map());}
          if (!yData.has("investigation2")) {yData.set("investigation2", new Y.Map());}
          if (!yData.has("investigation3")) {yData.set("investigation3", new Y.Map());}
          if (!yData.has("investigation4")) {yData.set("investigation4", new Y.Map());}
          if (!yData.has("doing0")) {yData.set("doing0", new Y.Map());}
          if (!yData.has("doing1")) {yData.set("doing1", new Y.Map());}
          if (!yData.has("doing2")) {yData.set("doing2", new Y.Map());}
          if (!yData.has("doing3")) {yData.set("doing3", new Y.Map());}
          if (!yData.has("doing4")) {yData.set("doing4", new Y.Map());}
          if (!yData.has("done0")) {yData.set("done0", new Y.Map());}
          if (!yData.has("done1")) {yData.set("done1", new Y.Map());}
          if (!yData.has("done2")) {yData.set("done2", new Y.Map());}
          if (!yData.has("done3")) {yData.set("done3", new Y.Map());}
          if (!yData.has("done4")) {yData.set("done4", new Y.Map());}
          if(!yData.has("taskCount")){yData.set("taskCount",0);}
          if(!yData.has("changeTime")){yData.set("changeTime",0);}
          if (!yData.has("SprintInfo")) {
            const sprintInfo = new Y.Map();
            sprintInfo.set("SprintTotal",1);
            sprintInfo.set("CurrentSprint",1);
            yData.set("SprintInfo", sprintInfo);
          }
          if (!yData.has("MemberName")) {yData.set("MemberName", new Y.Map());}
          if(!yData.has("editedMember")){yData.set("editedMember",0);}
          //if(!yData.has("sprintState")){yData.set("sprintState", "nonState");}
          if (!yData.has("TaskAction")) {
            const action = new Y.Map();
            action.set("changeTime",0);
            action.set("editedMember",0);
            action.set("sprintState","nonState");
            action.set("actionGrid",0);
            action.set("actionTaskKey",0);
            action.set("actionTaskTitle","");
            yData.set("TaskAction", action);
          }
        });

        taskCount = yData.get("taskCount");
        
        updateData();  // 初回のデータ更新
        applyYjsUpdate({
          actionType: "playerLogin",
          actionGrid: null,
          actionTaskKey: null,
          actionTaskTitle: null,
          yjsUpdate: () => {
            //とりあえず空白
          }
        })
        }
        initilezation();
        
      }
    }

    wsProvider.on("sync",handleSync);
    

    wsProvider.on("sync",() =>{
      isSynced = true;
      //initilization();
    })
    
    //updateData();  // 初回のデータ更新
    const yDocObserver = yDoc.on("update", () => {
      //const yData2 = yDoc.getMap(`sprintboard-${teamNumber}:${teamNumber}`);
      if(yData != null){
        updateData(); // データ更新
      }
      
    });

    
  
    return () => {
      yDoc.off("update", yDocObserver); // クリーンアップ
    };
  }, []); // 空の依存配列を渡すことで初回マウント時のみ実行

  
  
  

  useSetYData((newData) => {
    
    const newKey = Object.keys(newData)[0];
    const newValue = newData[newKey];
    const newZIndex = bringToFromt(yData.get("ProductBacklog"),0);
    const updatedTask = {...newValue,zIndex:newZIndex};

    applyYjsUpdate({
      actionType: "make",
      actionGrid: "ProductBacklog",
      actionTaskKey: taskCount + 1,
      actionTaskTitle: newValue.taskTitle,
      yjsUpdate: () => {
        yData.get("ProductBacklog").set(newKey,updatedTask);
        taskCount = yData.get("taskCount") + 1;
        yData.set("taskCount",taskCount);
      }
    })
    
    updateData();
  });

  

  const updateData = () => {
    const allEntries = updateTasks(updateDataOnTaskMove);
    setData({
      ProductBacklog: allEntries["ProductBacklog"],
        SprintBacklog: allEntries["SprintBacklog"],
        investigation0: allEntries["investigation0"],
        investigation1: allEntries["investigation1"],
        investigation2: allEntries["investigation2"],
        investigation3: allEntries["investigation3"],
        investigation4: allEntries["investigation4"],
        doing0: allEntries["doing0"],
        doing1: allEntries["doing1"],
        doing2: allEntries["doing2"],
        doing3: allEntries["doing3"],
        doing4: allEntries["doing4"],
        done0: allEntries["done0"],
        done1: allEntries["done1"],
        done2: allEntries["done2"],
        done3: allEntries["done3"],
        done4: allEntries["done4"],
    });
    
  };

  

  return (
    <div className="allgrid">
      <div className="header">
        <div className="history" id="history" onClick={() => historyDisplay(teamNumber)}>
          <button className="historyButton" id="historyButton" /* 履歴*/>履歴</button>
        </div>
        <div className="sprintInfoDiv">
          <div className="totalSprintDiv"/* スプリント数を入力*/>
            <label>スプリント数を入力</label>
            <input
            type="number"
            min={1}
            max={10}
            value={yData?.get("SprintInfo").get("SprintTotal")}
            onChange={(e) => {
              const val = parseInt(e.target.value);
              //yData?.get("SprintInfo").set("SprintTotal",val);
              if(isNaN(val) || val < 1 || val > 10)return;
              applyYjsUpdate({
                actionType: "SprintTotal",
                actionGrid: null,
                actionTaskKey: null,
                actionTaskTitle: null,
                yjsUpdate: () => {
                  yData?.get("SprintInfo").set("SprintTotal",val);
                }
              })
            }}
            ></input>
          </div>
          <div className="currentSprintDiv">
            <select
            value={yData?.get("SprintInfo").get("CurrentSprint")}
            onChange={(e) => applyYjsUpdate({
              actionType: "ChangeCurrentSprint",
              actionGrid: null,
              actionTaskKey: null,
              actionTaskTitle: null,
              yjsUpdate: () => {
                yData?.get("SprintInfo").set("CurrentSprint",parseInt(e.target.value));
              }
            })/*yData?.get("SprintInfo").set("CurrentSprint")*/}
            >
              {Array.from({length: yData?.get("SprintInfo").get("SprintTotal")},(_,i) => (
                <option key={i + 1} value={i + 1}/*スプリント */>スプリント{i + 1}</option>
              ))}

            </select>
          </div>
        </div>
        {/*
        <select id="sprintCount" onChange={sprintStateUpdate}>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>

        </select>
        */}
        
      </div>

      <div className="main">
        
        <div className="items">
          
          <div className="item pBacklog" /*onClick={handleButtonClick} newChange*/ /*プロダクトバックログ*/>プロダクトバックログ
            <button id="makeTask" onClick={handleButtonClick}>+</button>
          </div>
          <div className="item sBacklog" /*スプリントバックログ*/>スプリントバックログ</div>
          <div className="item nameGrid" /*名前*/>名前
            <button className="editMemberName" onClick={openNameDicision} /*編集*/>編集</button>
          </div>
          <div className="item investigation" /*調査中*/>調査中</div>
          <div className="item doing" >Doing</div>
          <div className="item done" >Done</div>
        </div>



        <div className="grids">
          <div className="grid  gridCSS pBacklog" id="ProductBacklog">
            {Array.isArray(data.ProductBacklog) ? data.ProductBacklog : null}
            
          </div>

          <div className="grid gridCSS sBacklog" id="SprintBacklog">
            {Array.isArray(data.SprintBacklog) ? data.SprintBacklog : null}
          </div>

          <div className="gridCSS nameGrid">
            <div className="nameTag name0"><span>{yData?.get("MemberName")?.get("0") || "0"}</span></div>
            <div className="nameTag name1"><span>{yData?.get("MemberName")?.get("1") || "1"}</span></div>
            <div className="nameTag name2"><span>{yData?.get("MemberName")?.get("2") || "2"}</span></div>
            <div className="nameTag name3"><span>{yData?.get("MemberName")?.get("3") || "3"}</span></div>
            <div className="nameTag name4"><span>{yData?.get("MemberName")?.get("4") || "4"}</span></div>
            
          </div>

          <div className=" gridCSS investigation" id="investigation">
            <div className="grid type0" id="investigation0">{Array.isArray(data.investigation0) ? data.investigation0 : null}</div>
            <div className="grid type1" id="investigation1">{Array.isArray(data.investigation1) ? data.investigation1 : null}</div>
            <div className="grid type2" id="investigation2">{Array.isArray(data.investigation2) ? data.investigation2 : null}</div>
            <div className="grid type3" id="investigation3">{Array.isArray(data.investigation3) ? data.investigation3 : null}</div>
            <div className="grid type4" id="investigation4">{Array.isArray(data.investigation4) ? data.investigation4 : null}</div>
            
          </div>
          <div className=" gridCSS doing" id="doing">
            <div className="grid type0" id="doing0">{Array.isArray(data.doing0) ? data.doing0 : null}</div>
            <div className="grid type1" id="doing1">{Array.isArray(data.doing1) ? data.doing1 : null}</div>
            <div className="grid type2" id="doing2">{Array.isArray(data.doing2) ? data.doing2 : null}</div>
            <div className="grid type3" id="doing3">{Array.isArray(data.doing3) ? data.doing3 : null}</div>
            <div className="grid type4" id="doing4">{Array.isArray(data.doing4) ? data.doing4 : null}</div>
          </div>
          <div className=" gridCSS done" id="done">
            <div className="grid type0" id="done0">{Array.isArray(data.done0) ? data.done0 : null}</div>
            <div className="grid type1" id="done1">{Array.isArray(data.done1) ? data.done1 : null}</div>
            <div className="grid type2" id="done2">{Array.isArray(data.done2) ? data.done2 : null}</div>
            <div className="grid type3" id="done3">{Array.isArray(data.done3) ? data.done3 : null}</div>
            <div className="grid type4" id="done4">{Array.isArray(data.done4) ? data.done4 : null}</div>
          </div>
        </div>        
        
      </div>
      
      
    </div>
    
  );
};
export {Sprintboard,changeWH,restoreSprint,deleteTask,editTask,updateMemberName,setWebsocketProvider};



function updateTasks(updateDataOnTaskMove){
  const allEntries = {};
  maps.forEach((mapName) => {
    const mapData = yData.get(mapName);
    //MemberName add -------------------------するかどうか
    const mapEntries = mapData ? Array.from(mapData.entries()):[];
    allEntries[mapName] = mapEntries.map(([key,value]) => (
      <div key={key} className="grid-item" data-keyvalue={key} 
      onDoubleClick={() => {handleItemClick(key,value,mapName,yData.get(mapName).get(key));}} draggable="true"
      onDragStart={(event) => dragMoveStart(event)} 
      onDragEnd={(event) => dragMoveEnd(event,updateDataOnTaskMove)}
      style={{/*left:`${value.elemLeft}px`,top:`${value.elemTop}px`,*/
              left:`${value.elemLeft}%`,top:`${value.elemTop}%`,
              width:`${value.width}px`,height:`${value.height}px`,
              background: value.taskColor || "white",zIndex:value.zIndex}}>

        <p className="iconTitle">{value.taskTitle}</p>
        <p className="difficultyText">{value.difficulty ?? 0}</p>
        
      </div>
    ))
  })
  resizeObserver();
  return allEntries;
}

function bringToFromt(mapForGrid,zIndex){
  const maxZ = Math.max(0, ...Array.from(mapForGrid.values()).map(v => v.zIndex || 1));
  if(zIndex >= maxZ) return zIndex;
  return maxZ + 1;
}

